<template>
  <div class="pc_banner">
    <!-- 搜索 -->
    <div class="pc_select">
      <el-row>
        <el-col :span="20"
          ><div class="grid-content bg-purple">
            <el-form
              :inline="true"
              :model="selectForm"
              class="demo-form-inline"
              @submit.native.prevent
            >
              <!-- <el-form-item label='ID'>
                <el-input v-model='selectForm.id' placeholder='ID'></el-input>
              </el-form-item> -->
              <el-form-item label="">
                <el-select
                  v-model="selectForm.device"
                  clearable
                  @clear="handleClear"
                  placeholder="选择设备信息"
                  ref="selectref1"
                  @keydown.enter.native="handleEnterChange('selectref1')"
                >
                  <el-option label="PC站" value="0"></el-option>
                  <el-option label="移动站" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-select
                  v-model="selectForm.type"
                  clearable
                  @clear="handleClear"
                  placeholder="选择图片位置"
                  ref="selectref2"
                  @keydown.enter.native="handleEnterChange('selectref2')"
                >
                  <el-option label="首页banner图" value="1"></el-option>
                  <el-option label="课程体系banner图" value="2"></el-option>
                  <el-option label="赛事banner图" value="3"></el-option>
                  <el-option label="社区banner图" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSelect">搜索</el-button>
              </el-form-item>
            </el-form>
          </div></el-col
        >
        <el-col :span="2"
          ><div class="grid-content bg-purple">&nbsp;</div></el-col
        >
        <el-col :span="2"
          ><div class="grid-content bg-purple-light">
            <div class="cratebtn">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="createBannerOpen"
                >新增banner图</el-button
              >
            </div>
          </div></el-col
        >
      </el-row>

      <!-- 添加banner信息 -->
    </div>
    <!-- 表格区域 -->
    <el-table
      :data="getTabeData"
      border
      v-loading="loading"
      style="width: 100%"
      height="580"
    >
      <el-table-column fixed prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="device" label="设备信息" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.device === 0">PC站</el-tag>
          <el-tag type="info" v-else>移动站</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="图片所属" width="160">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 1">首页banner图</el-tag>
          <el-tag v-else-if="scope.row.type === 2">课程体系banner图</el-tag>
          <el-tag v-else-if="scope.row.type === 3">赛事banner图</el-tag>
          <el-tag v-else>社区banner图</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="addr" label="图片预览" width="240">
        <template slot-scope="scope">
          <img :src="scope.row.addr" alt="图片" class="imgs" />
          <!-- <Image :url='scope.row.addr'></Image> -->
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status === 0">上线</el-tag>
          <el-tag type="warning" v-else>待上线</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="发布时间" width="190">
      </el-table-column>
      <el-table-column prop="update_time" label="更新时间" width="190">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="220">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="查看" placement="top">
            <el-button
              @click="handleLook(scope.row)"
              type="primary"
              icon="el-icon-view"
              size="small"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button
              type="success"
              icon="el-icon-edit"
              size="small"
              @click="handleEditor(scope.row.id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="small"
              @click="handleDeleteClick(scope.row.id)"
            ></el-button>
          </el-tooltip>

          <!-- handleClick事件传入scope.row进行操作时，会影响整个一行数据的变动，留作问题探索(转变策略为，点击编辑请求对应ID的信息) -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pc_banner_page">
      <div class="block">
        <!-- <span class='demonstration'>完整功能</span> -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 30]"
          :page-size="sizePage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 查看弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="centerDialogVisible"
      width="50%"
      :lock-scroll="false"
      @closed="closed('lookForm')"
    >
      <el-form
        label-position="lift"
        label-width="100px"
        :model="lookForm"
        ref="lookForm"
      >
        <el-form-item label="序号 :">
          <el-tag type="success">{{ lookForm.id }}</el-tag>
        </el-form-item>
        <el-form-item label="设备信息 :">
          <el-tag type="success" v-if="lookForm.device === 0">PC站</el-tag>
          <el-tag type="success" v-else>移动站</el-tag>
        </el-form-item>
        <el-form-item label="图片所属 :">
          <el-tag type="success" v-if="lookForm.type === 1"
            >首页banner图</el-tag
          >
          <el-tag type="success" v-else-if="lookForm.type === 2"
            >课程体系banner图</el-tag
          >
          <el-tag type="success" v-else-if="lookForm.type === 3"
            >赛事banner图</el-tag
          >
          <el-tag type="success" v-else>社区banner图</el-tag>
        </el-form-item>
        <el-form-item label="banner图片 :">
          <img :src="lookForm.addr" alt="" class="img_show" />
        </el-form-item>
        <el-form-item label="状态 :">
          <el-tag type="success" v-if="lookForm.status === 0">上线</el-tag>
          <el-tag type="success" v-else>待上线</el-tag>
        </el-form-item>
        <el-form-item label="创建时间 :">
          <el-tag type="success">{{ lookForm.create_time }}</el-tag>
        </el-form-item>
        <el-form-item label="更新时间 :">
          <el-tag type="success">{{ lookForm.update_time }}</el-tag>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="editorDialogVisible"
      width="50%"
      :lock-scroll="false"
      @closed="closed('editorForm')"
    >
      <el-form
        :label-position="'lift'"
        label-width="100px"
        :model="editorForm"
        ref="editorForm"
        :rules="rule"
        :validate-on-rule-change="false"
      >
        <el-form-item label="序号">
          <el-input v-model="editorForm.id" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="设备信息">
          <el-select
            v-model="editorForm.device"
            :disabled="true"
            placeholder="请选择设备类型"
          >
            <el-option label="PC站" value="0"></el-option>
            <el-option label="移动站" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图片所属">
          <el-select
            v-model="editorForm.type"
            :disabled="true"
            placeholder="请选择所属名称"
          >
            <el-option label="首页banner图" value="1"></el-option>
            <el-option label="课程体系banner图" value="2"></el-option>
            <el-option label="赛事banner图" value="3"></el-option>
            <el-option label="社区banner图" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="banner图片" prop="addr">
          <Upload
            v-if="editorDialogVisible"
            :initUrl="editorForm.addr"
            @change="handleUpload($event, editorForm, 'addr')"
          ></Upload>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="editorForm.status" placeholder="请选择状态">
            <el-option label="上线" value="0"></el-option>
            <el-option label="待上线" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input
            v-model="editorForm.create_time"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="上次更新时间">
          <el-input
            v-model="editorForm.update_time"
            :disabled="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editorDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editorSubmit('editorForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 新增banner图的弹出框 -->
    <el-dialog
      title="新增banner图"
      width="50%"
      :lock-scroll="false"
      :visible.sync="createBannerDialog"
      @closed="closed('createBannerForm')"
    >
      <el-form
        :model="newBannerForm"
        label-width="100px"
        ref="createBannerForm"
        :rules="rule"
        :validate-on-rule-change="false"
      >
        <el-form-item label="设备信息" prop="device">
          <el-select
            v-model="newBannerForm.device"
            placeholder="请选择设备信息"
          >
            <el-option label="PC站" value="0"></el-option>
            <el-option label="移动站" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图片所属" prop="type">
          <el-select
            v-model="newBannerForm.type"
            placeholder="请选择图片所属位置"
          >
            <el-option label="首页banner图" value="1"></el-option>
            <el-option label="课程体系banner图" value="2"></el-option>
            <el-option label="赛事banner图" value="3"></el-option>
            <el-option label="社区banner图" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="banner图片" prop="addr">
          <Upload
            v-if="createBannerDialog"
            @change="handleUpload($event, newBannerForm, 'addr')"
          ></Upload>
        </el-form-item>
        <el-form-item label="跳转链接" prop="url">
          <el-input v-model="newBannerForm.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="上线状态" prop="status">
          <el-select
            v-model="newBannerForm.status"
            placeholder="请选择上线状态"
          >
            <el-option label="上线" value="0"></el-option>
            <el-option label="待上线" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createBannerDialog = false">取 消</el-button>
        <el-button type="primary" @click="createSubmit('createBannerForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { bannerCreateFormRules } from 'untils/form_validation.js';
import {
  initBannerList,
  findBanners,
  saveBanners,
  deleteBanners
} from 'api/post/postApi.js';
// 引入组件
import Upload from 'common/upload/Upload';

export default {
  name: 'pc_banner',
  components: {
    Upload
  },
  data() {
    return {
      loading: true,
      tableData: [],
      // 分页功能参数
      total: 0,
      sizePage: 5,
      currentPage: 1,
      selectForm: {
        type: '',
        device: ''
      },
      centerDialogVisible: false,
      editorDialogVisible: false,
      createBannerDialog: false,
      lookForm: {},
      editorForm: {},
      newBannerForm: {},
      rule: null,
      title: '',
      fileList: []
    };
  },
  created() {
    // 数据初始化
    this.initData();
  },
  // 计算属性
  computed: {
    // 分页控制
    getTabeData: function () {
      const tableData = this.tableData.slice(
        (this.currentPage - 1) * this.sizePage,
        this.currentPage * this.sizePage
      );
      return tableData;
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      const { data: res } = await initBannerList();
      this.tableData = res.data;
      this.total = res.data.length;
      this.loading = false;
    },

    // 每页显示
    handleSizeChange(val) {
      this.sizePage = val;
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    // 查看
    handleLook(data) {
      // 查看页面
      this.title = '查看';
      this.flag = true;
      this.lookForm = data;

      this.centerDialogVisible = true;
    },
    // 编辑
    async handleEditor(bid) {
      this.title = '编辑';
      this.rule = bannerCreateFormRules;
      const params = { id: bid }; // 构造id参数
      const { data: res } = await findBanners(params);
      this.editorForm = res.data;
      // 修改数据类型，以作数据回显
      this.editorForm.device = this.editorForm.device.toString();
      this.editorForm.type = this.editorForm.type.toString();
      this.editorForm.status = this.editorForm.status.toString();
      this.editorDialogVisible = true;
    },
    // 公用的dialog清空逻辑
    closed(formName) {
      this.editorForm = {};
      this.lookForm = {};
      this.newBannerForm = {};
      this.fileList = [];
      this.rule = null;
      this.resetForm(formName);
    },
    // 更新
    editorSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data: res } = await saveBanners(this.editorForm);
          if (res.status !== 0) {
            // elementui组件 消息框
            this.$message.error('更新失败！');
          } else {
            this.$message.success('更新成功！');
            this.initData();
          }
          this.editorDialogVisible = false;
        } else {
          this.$message.error('表单验证未通过！');
          return false;
        }
      });
    },
    // 删除
    async handleDeleteClick(id) {
      // 询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该信息, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err);
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除！');
      }
      const params = { id: id }; // 构造参数
      const { data: res } = await deleteBanners(params);
      if (res.status !== 0) {
        this.$message.error('删除失败！');
      } else {
        this.$message.success('删除成功！');
      }
      this.initData();
    },
    // 新增banner按钮
    createBannerOpen() {
      this.rule = bannerCreateFormRules;
      this.createBannerDialog = true;
    },
    // 提交新增表单
    async createSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data: res } = await saveBanners(this.newBannerForm);
          if (res.status !== 0) {
            // elementui组件 消息框
            this.$message.error('新增banner失败！');
          } else {
            this.$message.success('新增banner成功！');
          }
          this.createBannerDialog = false;
          this.initData();
        } else {
          this.$message.error('表单验证未通过!');
          return false;
        }
      });
    },
    /**
     * 图片上传功能实现
     */
    // 上传回调
    handleUpload(value, form, item) {
      form[item] = value;
    },
    // 重置新增表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 搜索实现
    async onSelect() {
      const { data: res } = await initBannerList(this.selectForm);
      if (res.status !== 0) {
        this.$message.error('查找失败！');
        return;
      }
      this.$message.success('查找成功！');
      this.tableData = res.data;
      this.total = res.data.length;
    },
    // 回车阻止多选框弹出下拉框
    handleEnterChange(refName) {
      this.onSelect();
      this.$refs[refName].visible = false;
    },
    // 搜索清除
    handleClear() {
      this.selectForm={};
      this.initData();
    }
  }
};
</script>

<style scoped>
.pc_banner_page {
  height: 100px;
  width: 100%;
  margin-top: 5px;
  text-align: center;
}
.pc_select {
  width: 100%;
}
.imgs {
  width: 100%;
  height: 100px;
}
.img_show {
  width: 380px;
  height: 200px;
}
.cratebtn {
  float: right;
}
</style>